<template lang="pug">
.modal-bg.rounded.h-full.items-center.content-center.justify-center(:class="{ hidden: !showModal, flex: showModal }")
  .modal.rounded-lg.shadow.-mt-6.p-8
    h1 🙈
    p.text-lg.mt-2 You can't add more pages on the free plan.
      br
      | Please
      |
      a(href="/#/subscription") subscribe
      |  to add more
    p.mt-8
      a.btn-gootics(href="/#/subscription") Subscribe
    button.mt-6.btn.bg-transparent(@click="showModal=!showModal") Cancel
</template>

<script>
export default {
  props: {
    show: Boolean
  },
  data () {
    return {
      showModal: false
    }
  },
  watch: {
    show: function (val) {
      console.log('watch: ' + val)
      this.showModal = val
    }
  }
}
</script>

<style>
.modal-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,.3);
}
.modal {
  margin: 0 auto;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Modal.vue